import _ from 'lodash';

/**
 * @author James Adams
 */
function HasMenu(title, page, menuData){
  this.state.menuToggle='closed';
  this.state.pageTitle=title;
  this.state.page=page;
  this.state.item=null;
  this.state.selectedMenu=null;
  this.state.selectedSubMenu=null;
  this.menuData = Object.assign({}, menuData);

  this.resetState = Object.assign({}, this.state);


  /**
   * Toggle menu click.
   * @param {Event} event
   */
  this.handleToggleMenu=function(event){
    let toggle = this.state.menuToggle;
    if(toggle==='closed'){
      toggle = 'open';
    }else{
      toggle = 'closed';
    }
    this.setState({'menuToggle':toggle});
  };


  /**
   * Menu item click.
   * @param {Event} event
   */
  this.handleClickMenuItem=function(event){
    event.preventDefault();

    let pageId = event.target.dataset.id;
    if(pageId==='logout'){
      console.log('hit reserved logout id');
      //reset fam
      this.setState(this.resetState);
      //log out of the app
      this.acl.logout();
    } else{
      let md = this._findMenu(pageId, this.menuData.menuItems);

      if(md){
        if(md.children){
          if(this.state.selectedSubMenu === md.id){
            let state = _.cloneDeep(this.state);
            state.selectedSubMenu=null;
            this.setState(state);
          }else{
            let state = _.cloneDeep(this.state);
            state.selectedSubMenu=md.id;
            this.setState(state);
          }
        }else{
          let state = _.cloneDeep(this.state);
          state.selectedSubMenu=null;
          state.menuToggle='closed';
          this.setState(state);
          window.location.hash = '#'+pageId;
        }
      }
    }
  };


  /**
   * Navigate menu.
   * @param {string} id
   */
  this._navigateMenu=function(id, item){
    let hit = this._findMenu(id, this.menuData.menuItems);
    for(var i=0,md;(md=this.menuData.menuItems[i]);i++){
      let hasPermission = this.acl && md.feature? _gatherPermission(this.acl.features(), md):true;
      if(md.id === id && hasPermission){
        hit = md;
        break;
      }
    }

    if(hit){
        document.onkeydown = null;
        document.onkeyup = null;
        document.title = hit.title+' - '+ this.state.pageTitle;
        this.setState({
          'page':hit.id,
          'item':item,
          'selectedMenu':hit
        });
    }else{
      console.warn('Page not found');
    }
  };


  /**
   *
   */
  this._findMenu=function(id, items){
    let hit = null;
    for(var i=0,md;(md=items[i]);i++){
      let hasPermission = this.acl && md.feature? _gatherPermission(this.acl.features(), md):true;
      if(hasPermission){
        if(md.id === id){
          hit = md;
          break;
        } else if(md.children){
          hit = this._findMenu(id, md.children);

          if(hit){
            break;
          }
        }
      }
    }
    return hit;
  };


  /**
   * Discern if a user has permission to a menu item.
   * @param {object} md menu data
   * @param {string} role
   */
  function _gatherPermission(features, md){
    let hasPermission = false;
    const featureName = md.feature.replace('-','');
    const negate = md.feature.includes('-');
    if(featureName){
      if(features[featureName] && negate===false){
        hasPermission = true;
      } else if(negate && features[featureName]===false){
        hasPermission = true;
      }
    }
    return hasPermission;
  }


  /**
   * Hash change event.
   */
  this.hashChange=function(){
    const hash = window.location.hash.replace('#','');
    const keys = hash.split('_');
    const page = keys[0];
    const item = keys[1]||null;
    this._navigateMenu(page, item);
  };

  //main
  window.onhashchange=this.hashChange.bind(this);
}

export default HasMenu;
